const initGallery = () => {
    initCarousel("[data-carousel-gallery]", cellAlign.center, false, true, false, false, true);
};
